export default function TermsOfServicePage() {
  return <iframe src="/legal/terms-of-service.html" className="w-screen px-10" title="Terms of Service"></iframe>

}
